/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { ROUTES } from "../../../../utils/routes";
import Axios from "axios";
import { getAll } from "../../../../utils/requests/dynamicReq";
import { paths } from "../../../../utils/paths";

//search feature
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import Col from "react-bootstrap/esm/Col";
import Form from "react-bootstrap/esm/Form";
import InputGroup from "react-bootstrap/esm/InputGroup";
import { IInvestShortTE } from "../../../../interfaces/InvestigatorShortTE";
import * as XLSX from "xlsx";

export const TelefonoEmail: FC = () => {
  const history = useHistory();

  const [isLoading, setIsLoading] = useState(false);
  const [investigators, setInvestigators] = useState<IInvestShortTE[]>([]);
  const [filteredInvestigators, setFilteredInvestigators] = useState<
    IInvestShortTE[]
  >([]);
  const [search, setSearch] = useState("");

  const [sortConfig, setSortConfig] = useState<{
    key: string;
    direction: "asc" | "desc";
  }>({
    key: "apellidos",
    direction: "asc",
  });

  const isMountedRef = useRef(false);
  const source = Axios.CancelToken.source();
  const { INVESTIGATORS } = paths;

  useEffect(() => {
    setIsLoading(true);
    isMountedRef.current = true;
    loadInvestigators();
    return () => {
      isMountedRef.current = false;
      source.cancel();
    };
  }, []);

  const loadInvestigators = async () => {
    try {
      const response = await getAll(INVESTIGATORS, source);
      if (isMountedRef.current) {
        filterInvestigators(response);
      }
      setIsLoading(false);
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };

  const normalize = (text: string) =>
    text
      ?.normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase() ?? "";

  const filterInvestigators = (rawInvestigators: any[]) => {
    const investigators: IInvestShortTE[] = rawInvestigators.map(
      (investigator) => ({
        ...investigator,
        id: investigator.id,
        nombre: investigator.nombre,
        apellidos: investigator.apellidos,
      })
    );

    investigators.sort((a, b) =>
      normalize(a.apellidos).localeCompare(normalize(b.apellidos))
    );

    setInvestigators(investigators);
    setFilteredInvestigators(investigators);
  };

  const handleSearch = (value: string) => {
    setSearch(value);

    const normalizedValue = normalize(value);

    const filtered = investigators.filter((inv) => {
      const fullString = `
        ${inv.nombre}
        ${inv.apellidos}
        ${inv.email_personal}
        ${inv.telefono}
        ${inv.extension}
        ${inv.investigationGroup?.code}
      `.toString();

      return normalize(fullString).includes(normalizedValue);
    });

    setFilteredInvestigators(value ? filtered : investigators);
  };

  const handleSort = (key: string) => {
    let direction: "asc" | "desc" = "asc";

    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    setSortConfig({ key, direction });

    const sorted = [...filteredInvestigators].sort((a, b) => {
   const aVal = normalize(
     key.includes("investigationGroup")
       ? (a as any).investigationGroup?.code ?? ""
       : (a as any)[key] ?? ""
   );

   const bVal = normalize(
     key.includes("investigationGroup")
       ? (b as any).investigationGroup?.code ?? ""
       : (b as any)[key] ?? ""
   );


      return direction === "asc"
        ? aVal.localeCompare(bVal)
        : bVal.localeCompare(aVal);
    });

    setFilteredInvestigators(sorted);
  };

  const renderSortIcon = (key: string) => {
    if (sortConfig.key !== key) return "↕"; // sin ordenar

    return sortConfig.direction === "asc" ? "▲" : "▼";
  };

  const handleExportToExcel = () => {
    if (!investigators) return;

    const dataToExport = investigators.map((investigator: any) => ({
      Nombre: investigator.nombre,
      Apellidos: investigator.apellidos,
      Email: investigator.email_personal,
      Teléfono: investigator.telefono,
      Extensión: investigator.extension,
      Grupo: investigator.investigationGroup?.code || "-",
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Investigadores");
    XLSX.writeFile(workbook, "investigadores.xlsx");
  };

  return (
    <div className="container-fluid p-4">
      <div className="row">
        <div className="col d-flex justify-content-between align-items-center">
          <h3>Usuarios</h3>
          <div>
            <button className="baseBtn ml-2" onClick={handleExportToExcel}>
              Descargar Excel
            </button>
          </div>
        </div>
      </div>

      {/* Buscador */}
      <div className="row mt-4">
        <Form.Group as={Col}>
          <InputGroup className="shadow">
            <InputGroup.Prepend>
              <InputGroup.Text className="inputGroup ">
                <FontAwesomeIcon color="#0073B5" icon={faSearch} />
              </InputGroup.Text>
            </InputGroup.Prepend>
            <Form.Control
              type="text"
              placeholder="Buscar..."
              className="form-control"
              value={search}
              onChange={(e) => handleSearch(e.target.value)}
            />
          </InputGroup>
        </Form.Group>
      </div>

      {/* Tabla */}
      <div className="row">
        <div className="col-12">
          <table className="table table-hover mt-3">
            <thead>
              <tr>
                <th className="pointer" onClick={() => handleSort("nombre")}>
                  Nombre {renderSortIcon("nombre")}
                </th>

                <th className="pointer" onClick={() => handleSort("apellidos")}>
                  Apellidos {renderSortIcon("apellidos")}
                </th>

                <th>Email personal</th>

                <th>Teléfono</th>

                <th className="pointer" onClick={() => handleSort("extension")}>
                  Extensión {renderSortIcon("extension")}
                </th>

                <th
                  className="pointer"
                  onClick={() => handleSort("investigationGroup")}
                >
                  Grupo {renderSortIcon("investigationGroup")}
                </th>
              </tr>
            </thead>

            <tbody>
              {filteredInvestigators.map(
                ({
                  id,
                  nombre,
                  apellidos,
                  email_personal,
                  telefono,
                  extension,
                  investigationGroup,
                }) => (
                  <tr key={id} className="pointer">
                    <td>{nombre}</td>
                    <td>{apellidos}</td>
                    <td>
                      {email_personal ? (
                        <a
                          href={`mailto:${email_personal}`}
                          onClick={(e) => e.stopPropagation()}
                        >
                          {email_personal}
                        </a>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td>{telefono || "-"}</td>
                    <td>{extension || "-"}</td>
                    <td>{investigationGroup?.code || "-"}</td>
                  </tr>
                )
              )}
            </tbody>
          </table>

          {isLoading && (
            <div className="d-flex justify-content-center">
              <div className="spinner-border mt-5" role="status" />
            </div>
          )}

          {!filteredInvestigators.length && !isLoading && (
            <div className="d-flex justify-content-center mb-3">
              <h5>- No existen usuarios -</h5>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
